import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import store from "@/store";
import { useRoute, useRouter } from "vue-router/composables";
import useGetUserPlatform from "@/composables/use-get-user-platform";


export default /*#__PURE__*/_defineComponent({
  __name: 'enter-totp-verification-code',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const verificationCode = ref("");

const isCodeValid = computed(() => {
  return RegExp(/^[0-9]{6}$/).test(verificationCode.value);
});

const onVerifyCode = async () => {
  const userPlatform = await useGetUserPlatform();

  const request = await useHttpRequest<{
    success: string;
    message: string;
    temporaryToken: string;
    accessToken: string;
  }>({
    method: "POST",
    url: "staff/2fa/verify-totp-code",
    loadingProperty: null,
    showSuccessMessage: true,
    fullScreenLoaderMessage: "Verifying...",
    showFullScreenLoader: true,
    body: {
      code: verificationCode.value,
      temporaryToken: route.params.temporaryToken,
      platform: userPlatform,
    },
  });
  if (!request) return;
  if (request.success && request.message == "Login Successful") {
    store.commit("LOGIN_USER", request);
    router.replace({ path: "/dashboard/home" });
  } else if (
    request.message == "Too much time has passed, please login again"
  ) {
    return router.replace("/login");
  }
};

onMounted(() => {
  //If we have no temporaryToken in memory it means the user refreshed so we take them back to Login Screen
  if (!route.params.temporaryToken) {
    return router.replace({ name: "Login" });
  }
});

return { __sfc: true,route, router, verificationCode, isCodeValid, onVerifyCode }
}

})